export const DEPOSIT_ACTIVITY_CONTAINER_TAG_NAME = 'deposit-activity-container';
